// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

/** FollowTabType are defined in the FollowCommonFields in the interactions microservice definitions */
export type FollowTabType = 'SUGGESTED_FOR_YOU' | 'FACEBOOK_FRIENDS';

type FollowTabTypeContext = {|
  tabType: FollowTabType,
|};

/** null value if context does not exist */
// $FlowFixMe92
export default React.createContext((null: ?FollowTabTypeContext));
